const Layout = ({ children, previewMode, ...props }) => {
  return (
    <>
      <div className={`root ${previewMode ? "previewmode" : ""}`}>
        {props.show && <div className={"modal-backdrop fade show"}></div>}
        {children}
      </div>
    </>
  )
}

export default Layout
